import { createSlice } from "@reduxjs/toolkit";

const ComponentStore = createSlice({
  name: "Component",   // convention: use lowercase for slice name
  initialState: { 
    isSideBar: false,
    isHeaderBar:true,
    isProductModelOpen:false,
    isBrandAddOpen:false,
    isColor:false,
    isSize:false,
    isHomeScreen:false,
    categoryId:'',
    refreshColorList: false,
  },
  reducers: {
    ComponentUpdate: (state, action) => {
      state.isSideBar = action.payload.isSideBar;
      state.isProductModelOpen = action.payload.isProductModelOpen;
      state.isBrandAddOpen = action.payload.isBrandAddOpen;
      state.isColor = action.payload.isColor;
      state.isSize = action.payload.isSize;
      state.isHomeScreen = action.payload.isHomeScreen;
      state.categoryId = action.payload.categoryId;
    },
    toggleRefreshColor: (state) => {
      state.refreshColorList = !state.refreshColorList;
    },
    refreshComponent: (state) => {
     state.isSideBar = '';
    //  state.isHeaderBar = '';
     state.isProductModelOpen = '';
     state.isBrandAddOpen = '';
    }
  },
});

export const { ComponentUpdate, refreshComponent, toggleRefreshColor } = ComponentStore.actions;
export default ComponentStore.reducer;
